import React from "react";
import { CheckIcon } from "@heroicons/react/24/solid";

export default function Stepper({ steps, currentStep }) {
  return (
    <nav aria-label="Progress" className="mb-12">
      <ol role="list" className="flex items-center w-full max-w-3xl mx-auto">
        {steps.map((step, stepIdx) => (
          <li
            key={step.name}
            className={`relative flex-1 ${
              stepIdx !== steps.length - 1 ? "pr-8 sm:pr-20" : "flex-none"
            }`}
          >
            {step.id < currentStep ? (
              <>
                <div
                  className="absolute inset-0 flex items-center"
                  aria-hidden="true"
                >
                  <div className="h-1 w-full bg-indigo-600" />
                </div>
                <div className="relative flex h-10 w-10 items-center justify-center rounded-full bg-indigo-600 hover:bg-indigo-900">
                  <CheckIcon
                    className="h-6 w-6 text-white"
                    aria-hidden="true"
                  />
                  <span className="sr-only">{step.name}</span>
                </div>
              </>
            ) : step.id === currentStep ? (
              <>
                {stepIdx !== steps.length - 1 && (
                  <div
                    className="absolute inset-0 flex items-center"
                    aria-hidden="true"
                  >
                    <div className="h-1 w-full bg-gray-200" />
                  </div>
                )}
                <div
                  className="relative flex h-10 w-10 items-center justify-center rounded-full border-2 border-indigo-600 bg-white"
                  aria-current="step"
                >
                  <span
                    className="h-3 w-3 rounded-full bg-indigo-600"
                    aria-hidden="true"
                  />
                  <span className="sr-only">{step.name}</span>
                </div>
              </>
            ) : (
              <>
                {stepIdx !== steps.length - 1 && (
                  <div
                    className="absolute inset-0 flex items-center"
                    aria-hidden="true"
                  >
                    <div className="h-1 w-full bg-gray-200" />
                  </div>
                )}
                <div className="relative flex h-10 w-10 items-center justify-center rounded-full border-2 border-gray-300 bg-white hover:border-gray-400">
                  <span
                    className="h-3 w-3 rounded-full bg-transparent group-hover:bg-gray-300"
                    aria-hidden="true"
                  />
                  <span className="sr-only">{step.name}</span>
                </div>
              </>
            )}
            <span
              className={`absolute top-14 text-xs sm:text-sm font-medium w-24 sm:w-auto sm:whitespace-nowrap ${
                stepIdx === 0 
                  ? "left-0 text-left sm:left-5 sm:-translate-x-1/2 sm:text-center" 
                  : stepIdx === steps.length - 1 
                    ? "right-0 text-right sm:right-auto sm:left-5 sm:-translate-x-1/2 sm:text-center" 
                    : "left-5 -translate-x-1/2 text-center"
              } ${
                step.id <= currentStep ? "text-indigo-600" : "text-gray-500"
              }`}
            >
              {step.name}
            </span>
          </li>
        ))}
      </ol>
    </nav>
  );
}
